import { render, staticRenderFns } from "./BusinessProjectData.vue?vue&type=template&id=3d842f81&"
import script from "./BusinessProjectData.vue?vue&type=script&lang=ts&"
export * from "./BusinessProjectData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports